/**
 * MenuAltIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MenuAltIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M3 7a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2zm0 8a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MenuAltIcon = makeIcon('MenuAltIcon', MenuAltIconSvg)
